import { TRootItems } from '@modules/items';
import { useNewProductDialog } from '@modules/items/hooks/useNewProductDialog.hook';
import { useRootItemActions } from '@modules/items/hooks/useRootItemActions.hook';
import { useDocumentTitle } from '@shared/hooks';
import ShortcutsLayout from '@shared/components/nav/ShortcutsLayout';
import { MyTrainingTable, useResolvedTraining } from '@modules/mocks/training';
import PageHeader from './PageHeader';
import RootItemsGrid from './RootItemsGrid';
import ActivitySection from './ActivitySection';

type TProps = {
  data: TRootItems;
};

const HomeContent = ({ data }: TProps) => {
  const training = useResolvedTraining();
  const { actions, rootItemDialogs } = useRootItemActions();
  const { openNewProductDialog, newProductDialog } = useNewProductDialog();

  useDocumentTitle('Confideck');

  return (
    <ShortcutsLayout stableScrollbarGutter>
      <div className="flex flex-col mx-auto pt-8 pb-16 px-8 max-w-screen-xl">
        {rootItemDialogs}
        {newProductDialog}

        <PageHeader />

        <RootItemsGrid
          data={data}
          actions={actions}
          onNewProduct={openNewProductDialog}
          cardStatuses={data.cardStatuses}
        />

        <ActivitySection
          recentItems={data.recentItems}
          pendingApprovals={data.pendingApprovals ?? []}
          dashboardHref="/dashboard"
          trainingContent={training ? <MyTrainingTable /> : undefined}
        />
      </div>
    </ShortcutsLayout>
  );
};

export default HomeContent;
